import React from 'react';
import PropTypes from 'prop-types';
import { addLocaleData, IntlProvider } from 'react-intl';
import translations from '@wix/wix-vod-shared/src/common/i18n/translations';


function onLocaleLoad(func) {
  try {
    window.__Locale.onLoad(func);
  } catch (e) {
    func({
      locale: 'en',
      reactIntlData: [],
      translations: {},
    });
  }
}

onLocaleLoad(locale => {
  addLocaleData(locale.reactIntlData);
  translations.set(locale.translations);
});

export default class LocaleProvider extends React.Component {

  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    locale: null,
    isReady: false,
  };

  componentDidMount() {
    onLocaleLoad(({ locale }) =>
      this.setState({ locale, isReady: true })
    );
  }

  render() {
    const { locale, isReady } = this.state;
    const { children, ...props } = this.props;

    if (!isReady || !children) {
      return null;
    }

    return (
      <IntlProvider messages={translations.getAll()}
                    locale={locale}>
        {React.cloneElement(children, props)}
      </IntlProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/locale-provider.js